var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"bottom":'bottom'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.mensagem)+" "),_c('v-btn',{attrs:{"text":"","color":"green"},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Fechar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }